export default defineNuxtRouteMiddleware(async (to, from) => {
  if (from.path == '/' && !Object.keys(from.query).length) {
    return navigateTo({ path: '/home' });
  }
});
